import { defineComponent as _defineComponent } from 'vue'
import { resolveDynamicComponent as _resolveDynamicComponent, openBlock as _openBlock, createBlock as _createBlock, normalizeStyle as _normalizeStyle, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, renderSlot as _renderSlot, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, vShow as _vShow, withDirectives as _withDirectives, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5330aea4"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "d-flex" }
const _hoisted_2 = { class: "title" }
const _hoisted_3 = { class: "subtitle" }

import { withDefaults } from 'vue';
import { AlertIcon, AtomSelect, AtomTooltip, LoaderIcon } from '@/components/atoms';
import * as comps from '@/components/atoms';
import { IOptionsSelect } from '@/types';

interface IProps {
  title: string;
  subtitle?: string;
  label?: string;
  loading?: boolean;
  textTooltip?: string;
  icon?: string;
  iconColor?: string;
  iconBgColor?: string;
  hasDropdownList?: boolean;
  hasTabs?: boolean;
  footer?: boolean;
  optionsDropDown?: IOptionsSelect[];
  isCalendarSelect?: boolean;
}

export default /*#__PURE__*/_defineComponent({
  __name: 'MoleculeCard',
  props: {
    title: null,
    subtitle: null,
    label: null,
    loading: { type: Boolean, default: false },
    textTooltip: null,
    icon: null,
    iconColor: null,
    iconBgColor: null,
    hasDropdownList: { type: Boolean },
    hasTabs: { type: Boolean, default: false },
    footer: { type: Boolean },
    optionsDropDown: null,
    isCalendarSelect: { type: Boolean, default: false }
  },
  emits: ['onChangeDropDownList'],
  setup(__props: any, { emit }) {

const props = __props as { title: string, subtitle?: string, label?: string, loading: boolean, textTooltip?: string, icon?: string, iconColor?: string, iconBgColor?: string, hasDropdownList?: boolean, hasTabs: boolean, footer?: boolean, optionsDropDown?: IOptionsSelect[], isCalendarSelect: boolean };




function handleChangeDropdownList(event) {
  emit('onChangeDropDownList', event);
}

return (_ctx: any,_cache: any) => {
  const _component_v_card_title = _resolveComponent("v-card-title")!
  const _component_v_divider = _resolveComponent("v-divider")!
  const _component_v_card_item = _resolveComponent("v-card-item")!
  const _component_v_card = _resolveComponent("v-card")!

  return (_openBlock(), _createBlock(_component_v_card, { class: "border" }, {
    default: _withCtx(() => [
      _createVNode(_component_v_card_title, null, {
        default: _withCtx(() => [
          _createElementVNode("div", {
            class: _normalizeClass(["d-flex align-center header-card", { 'justify-space-between': !props.hasTabs, 'border-b': props.hasTabs }])
          }, [
            _createElementVNode("div", _hoisted_1, [
              (props.icon)
                ? (_openBlock(), _createElementBlock("div", {
                    key: 0,
                    style: _normalizeStyle({backgroundColor: props.iconBgColor}),
                    class: "pa-2 mr-2 rounded"
                  }, [
                    (_openBlock(), _createBlock(_resolveDynamicComponent(comps[props.icon]), {
                      color: props.iconColor
                    }, null, 8, ["color"]))
                  ], 4))
                : _createCommentVNode("", true),
              _createElementVNode("div", null, [
                _createElementVNode("p", _hoisted_2, _toDisplayString(props.title), 1),
                _createElementVNode("p", _hoisted_3, _toDisplayString(props.subtitle), 1)
              ])
            ]),
            (props.hasDropdownList)
              ? (_openBlock(), _createBlock(_unref(AtomSelect), {
                  key: 0,
                  onOnChangeDropDownList: handleChangeDropdownList,
                  isCalendar: __props.isCalendarSelect,
                  options: props.optionsDropDown,
                  label: props.label,
                  class: "m-0"
                }, null, 8, ["isCalendar", "options", "label"]))
              : _createCommentVNode("", true),
            (props.hasTabs)
              ? _renderSlot(_ctx.$slots, "tabs", { key: 1 })
              : _createCommentVNode("", true)
          ], 2)
        ]),
        _: 3
      }),
      _createVNode(_component_v_card_item, null, {
        default: _withCtx(() => [
          _withDirectives((_openBlock(), _createBlock(_resolveDynamicComponent(_unref(LoaderIcon)), { class: "ma-auto w-100" }, null, 512)), [
            [_vShow, props.loading]
          ]),
          _withDirectives(_createElementVNode("div", null, [
            _renderSlot(_ctx.$slots, "default"),
            (props.footer)
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                  _createVNode(_component_v_divider, { class: "mb-1" }),
                  _renderSlot(_ctx.$slots, "footer")
                ], 64))
              : _createCommentVNode("", true)
          ], 512), [
            [_vShow, !props.loading]
          ])
        ]),
        _: 3
      })
    ]),
    _: 3
  }))
}
}

})